import { z } from 'zod';

export const $UpdateCandidateResumeRequest = z.object({
  salary: z.number().nullable().optional(),
  currencyId: z.number().nullable().optional(),
  paymentPeriodId: z.number().nullable().optional(),
  experience: z.string().nullable().optional(),
  desiredJob: z.string().nullable().optional(),
  employmentDate: z.string().nullable().optional(),
  skillIds: z.array(z.number()).optional(),
  scheduleWorkIds: z.array(z.number()).optional(),
  employmentTypeIds: z.array(z.number()).optional(),
  activitySphereIds: z.array(z.number()).optional(),
});
